import { DutyHourTypeWithDetails } from '../types';
import { DutyHourTypeDto } from 'components/types';

export const dutyHourTypeConverter = (
  dto: DutyHourTypeDto
): DutyHourTypeWithDetails => ({
  ...dto,
  dutyTypeFlags: dto.dutyTypeFlags ?? [],
  valid: { from: new Date(dto.valid?.from), to: new Date(dto.valid?.to) }
});
